import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationRU from '../translate/ru.json'
import translationEN from '../translate/en.json'
import translationUK from '../translate/uk.json'

i18next.use(LanguageDetector).init({
  load: 'languageOnly',
  supportedLngs: ['ru', 'en', 'uk'],
  resources: {
    ru: {
      translation: translationRU,
    },
    en: {
      translation: translationEN,
    },
    uk: {
      translation: translationUK,
    },
  },
  fallbackLng: false,
  lng: 'uk',
  interpolation: {
    escapeValue: false,
  },
})

export default i18next
